import { logError } from '@zg-rentals/log-error';
import { identify } from '@zillow/universal-analytics';
import { getAnalyticsErrorType, getCookie, parseEncodedZuid } from './utils';

export function identifyUser(encodedZuid?: string) {
  try {
    const encodedZuidToUse = encodedZuid || parseEncodedZuid(getCookie('zjs_user_id'));
    identify(encodedZuidToUse || '');
  } catch (error) {
    logError({
      error,
      errorType: getAnalyticsErrorType('IdentifyUserError'),
    });
  }
}
